/**Import react section */
import React from 'react'
import propTypes from 'prop-types'
/**Import Material Ui section */
import { Grid, Typography } from '@material-ui/core'
/**Import helpers section */
import { GetColorNetWorkDays } from '../../../store/helpers/StatusHelper'
/**Import resources section */
import { createServicesStyle } from '../../../resources/styles/CreateServiceStyles'

const LABEL_STYLE = { marginRight: 8 }

/**
 * Read-only indicator of the business days a service has been open.
 *
 * `GetColorNetWorkDays` calls the `useServiceTableStyles` hook in its own body, so it is
 * invoked unconditionally here and the absent-value check runs afterwards. That keeps the
 * hook order stable no matter what `value` holds, which is why callers mount or omit this
 * component instead of guarding the helper call themselves.
 */
const NetworkDaysIndicator = (props) => {
	const { value } = props
	const classes = createServicesStyle()
	const coloredValue = GetColorNetWorkDays(value)

	// Explicit null/undefined check: `0` is a valid value (service opened today) and must render.
	if (value === null || value === undefined) return null

	return (
		<Grid container alignItems='center' wrap='nowrap'>
			<Grid item>
				<Typography className={classes.title} style={LABEL_STYLE}>
					{'Network Days'}
				</Typography>
			</Grid>
			<Grid item>{coloredValue}</Grid>
		</Grid>
	)
}

NetworkDaysIndicator.propTypes = {
	/**Business days the service has been open, as supplied by the backend. Accepts a string
	 * because the field is not on the detail response yet and its serialization is unconfirmed. */
	value: propTypes.oneOfType([propTypes.number, propTypes.string])
}

export default NetworkDaysIndicator
